import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CheckroomOutlinedIcon from "@mui/icons-material/CheckroomOutlined";

const UniformCodeChip = ({ code, noneLabel }) => {
  const hasCode = Boolean(code);
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        px: "10px",
        py: "0.5px",
        borderRadius: "4px",
        bgcolor: hasCode ? "var(--color-info-subtle)" : "var(--color-background-subtle)",
        border: hasCode ? "1px solid #DBEAFE" : "none",
      }}
    >
      {hasCode && (
        <CheckroomOutlinedIcon
          sx={{ fontSize: 12, color: "var(--color-info-default)" }}
        />
      )}
      <Typography
        sx={{
          fontSize: 10,
          fontWeight: 700,
          lineHeight: "15px",
          color: hasCode
            ? "var(--color-info-default)"
            : "var(--color-foreground-muted)",
        }}
      >
        {hasCode ? code : noneLabel}
      </Typography>
    </Box>
  );
};

UniformCodeChip.propTypes = {
  code: PropTypes.string,
  noneLabel: PropTypes.string.isRequired,
};

UniformCodeChip.defaultProps = {
  code: "",
};

export default UniformCodeChip;